import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_ALL_SUMMARIES,
  GET_SUMMARY_DETAILS,
  CREATE_SUMMARY,
} from "./actionTypes"

import { get, post } from "helpers/api_helper"
import { Notification } from "../../components/Common/Notification"
import {
  createSummaryFail,
  createSummarySuccess,
  getAllSummariesFail,
  getAllSummariesSuccess,
  getSummaryDetailsFail,
  getSummaryDetailsSuccess,
} from "./actions"

// Summary API functions - This line cannot be edited or removed
function getSummaryApi({ page, limit, searchText, filters }) {
  return get(
    `/summary/admin/all/?page=${page ? page : 1}&limit=${
      limit ? limit : 10
    }&search=${searchText ? searchText : ""}&status=${
      filters?.sort ?? ""
    }&medium=${filters?.medium ?? ""}&type=${filters.type ?? ""}`
  )
}

const getSummaryDetailsApi = summaryId => {
  return get(`/summary/admin/${summaryId}`)
}

const createSummaryApi = ({ summary }) => {
  return post("/summary/admin/new", summary)
}

function* fetchSummary({ payload }) {
  try {
    const response = yield call(getSummaryApi, payload)
    yield put(getAllSummariesSuccess(response))
  } catch (error) {
    yield put(getAllSummariesFail(error))
  }
}

function* fetchSummaryDetails({ payload: summaryId }) {
  try {
    const response = yield call(getSummaryDetailsApi, summaryId)
    yield put(getSummaryDetailsSuccess(response))
  } catch (error) {
    yield put(getSummaryDetailsFail(error))
  }
}

function* onCreateSummary({ payload }) {
  try {
    const response = yield call(createSummaryApi, payload)

    yield put(createSummarySuccess(response))
    payload?.onCloseClick()
    doneNotification("Summary Created Successfully!")
  } catch (error) {
    console.log(error)
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(createSummaryFail(error))
  }
}

function* SummarySaga() {
  yield takeEvery(GET_ALL_SUMMARIES, fetchSummary)
  yield takeEvery(GET_SUMMARY_DETAILS, fetchSummaryDetails)
  yield takeEvery(CREATE_SUMMARY, onCreateSummary)
}

export default SummarySaga

function doneNotification(message) {
  Notification({
    type: "success",
    message: message,
    title: "",
  })
}
